export default __webpack_public_path__ + "tab5_videob3e983.mp4";